import { createFeature, createReducer, on } from '@ngrx/store';
import { Category } from '@emi/shared/models';
import * as categoryActions from './category-action';
import * as commonActions from '../common-actions';

export interface CategoryState {
    categories: Category[];
    searchedCategories: Category[];
    searchText: string | null;
    loading: boolean;
    failed: boolean;
    error: string;
}

export const categoryFeatureKey = 'categoryfilters';

const initialState: CategoryState = {
    categories: [],
    searchedCategories: [],
    searchText: null,
    loading: false,
    failed: false,
    error: '',
};

export const categoryFeature = createFeature({
    name: categoryFeatureKey,
    reducer: createReducer(
        initialState,
        on(categoryActions.getCategoriesSuccess, (state, { categories }) => {
            return {
                ...state,
                categories,
                loading: false,
            };
        }),
        on(categoryActions.isLoadingCategories, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(categoryActions.getCategoriesFailure, (state, { error }) => {
            return {
                ...state,
                loading: false,
                failed: true,
                error: error.message,
            };
        }),
        on(categoryActions.searchCategories, (state, { searchText }) => {
            return {
                ...state,
                loading: state.searchText !== searchText,
            };
        }),
        on(categoryActions.searchCategoriesSuccess, (state, { searchText, categories }) => {
            return {
                ...state,
                searchedCategories: categories,
                searchText,
                loading: false,
            };
        }),
        on(commonActions.clearFilters, () => {
            return initialState;
        })
    ),
});
